<template>
  <nav id="mainnav-container">
    <div id="mainnav" v-show="show">
      <div id="mainnav-menu-wrap">
        <div class="nano">
          <div class="nano-content">
            <ul
              id="mainnav-menu"
              class="list-group"
              :class="{ smallmenu: menus.length > 10 }"
            >
              <template v-for="item in menus">
                <li class="list-header" v-if="item.listHeader">
                  {{ item.listHeader }}
                </li>
                <li
                  :class="{ 'active-sub': $route.meta.en_name == item.en_name }"
                >
                  <router-link :to="item.path">
                    <i :class="item.icon"></i>
                    <span class="menu-title">{{ item.name }}</span>
                  </router-link>
                </li>
              </template>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </nav>
</template>

<script>
import { mapGetters } from 'vuex'

import { hasAuth } from '../permission'
const siderMenus = {
  user: [
    {
      path: '/users/index',
      listHeader: '人员管理',
      name: '用户列表',
      en_name: 'users',
      icon: 'ion-person-stalker',
      meta: { auth_id: 11100 },
    },
    {
      path: '/roles',
      listHeader: '角色管理',
      name: '角色列表',
      en_name: 'roles',
      icon: 'ion-at',
      meta: { auth_id: 12100 },
    },
    // {
    // 	path: '/function_modules',
    // 	name: '模块管理',
    // 	en_name: 'function_modules',
    // 	icon: 'ion-unlocked'
    // }
  ],
  order: [
    {
      path: '/order_demands',
      listHeader: '需求管理',
      name: '需求列表',
      en_name: 'order_demands',
      icon: 'ion-clipboard',
      meta: { auth_id: 31100 },
    },
    {
      path: '/orders/index',
      listHeader: '订单管理',
      name: '全部订单',
      en_name: 'orders',
      icon: 'ion-navicon-round',
      meta: { auth_id: 32100 },
    },
    {
      path: '/orders/ongoing',
      name: '进行订单',
      en_name: 'orders_ongoing',
      icon: 'ion-arrow-swap',
      meta: { auth_id: 32100 },
    },
    {
      path: '/orders/pause',
      name: '暂停订单',
      en_name: 'orders_pause',
      icon: 'ion-pause',
      meta: { auth_id: 32100 },
    },
    {
      path: '/orders/close',
      name: '关闭订单',
      en_name: 'orders_close',
      icon: 'ion-close',
      meta: { auth_id: 32100 },
    },
    {
      path: '/orders/archive',
      name: '完成订单',
      en_name: 'orders_archive',
      icon: 'ion-checkmark',
      meta: { auth_id: 32100 },
    },
    // {
    //   path: '/repair_orders',
    //   listHeader: '维修管理',
    //   name: '维修单列表',
    //   en_name: 'repair_orders',
    //   icon: 'ion-document',
    //   meta: { auth_id: 33100 },
    // },
    {
      path: '/factories',
      listHeader: '外协厂家管理',
      name: '厂家列表',
      en_name: 'factories',
      icon: 'ion-hammer',
      meta: { auth_id: 33100 },
    },
    {
      path: '/form_params',
      listHeader: '配置管理',
      name: '字段列表',
      en_name: 'form_params',
      icon: 'ion-clipboard',
      meta: { auth_id: 34101 },
    },
    {
      path: '/flow_set',
      name: '流程负责人',
      en_name: 'flow_set',
      icon: 'ion-person-stalker',
      meta: { auth_id: 34102 },
    },
  ],
  produce: [
    {
      path: '/products',
      listHeader: '生产管理',
      name: '钻头列表',
      en_name: 'products',
      icon: 'ion-settings',
      meta: { auth_id: 43101 },
    },
    {
      path: '/flows',
      name: '派工看板',
      en_name: 'flows',
      icon: 'ion-navicon-round',
      meta: { auth_id: 43103 },
    },
    {
      path: '/flow_histories',
      name: '历史生产',
      en_name: 'flow_histories',
      icon: 'ion-navicon-round',
      meta: { auth_id: 43103 },
    },
    {
      path: '/pause_flows',
      name: '暂停生产',
      en_name: 'pause_flows',
      icon: 'ion-pause',
      meta: { auth_id: 43103 },
    },
    {
      path: '/cancel_flows',
      name: '关闭生产',
      en_name: 'cancel_flows',
      icon: 'ion-close',
      meta: { auth_id: 43103 },
    },
    {
      path: '/mytask',
      listHeader: '生产任务',
      name: '待完成任务',
      en_name: 'mytask',
      icon: 'ion-document',
      meta: { auth_id: 42101 },
    },
    {
      path: '/statistics/manhour',
      listHeader: '统计',
      name: '工时统计',
      en_name: 'statistics',
      icon: 'ion-document',
      meta: { auth_id: 44101 },
    },
    {
      path: '/flow_templates',
      listHeader: '流程模板',
      name: '模板管理',
      en_name: 'flow_templates',
      icon: 'ion-levels',
      meta: { auth_id: 41100 },
    },
    {
      path: '/flow_nodes',
      name: '工序管理',
      en_name: 'flow_nodes',
      icon: 'ion-cube',
      meta: { auth_id: 41100 },
    },
  ],
  stock: [
    {
      path: '/stock/drills',
      listHeader: '钻头管理',
      name: '库存',
      en_name: 'stock_drill',
      icon: 'ion-navicon-round',
      meta: { auth_id: 51102 },
    },
    {
      path: '/stock/drills/in',
      name: '入库',
      en_name: 'stock_drill_in',
      icon: 'ion-plus-round',
      meta: { auth_id: 51102 },
    },
    {
      path: '/stock/drills/out',
      name: '已出库',
      en_name: 'stock_drill_out',
      icon: 'ion-minus-round',
      meta: { auth_id: 51102 },
    },
    // {
    //   path: '/stock/pdcs',
    //   listHeader: '复合片管理',
    //   name: '库存',
    //   en_name: 'stock_pdc',
    //   icon: 'ion-navicon-round',
    //   meta: { auth_id: 51201 },
    // },
    // {
    //   path: '/stock/pdcs/in',
    //   name: '入库',
    //   en_name: 'stock_pdc_in',
    //   icon: 'ion-plus-round',
    //   meta: { auth_id: 51201 },
    // },
    // {
    //   path: '/stock/pdcs/out',
    //   name: '出库',
    //   en_name: 'stock_pdc_out',
    //   icon: 'ion-minus-round',
    //   meta: { auth_id: 51201 },
    // },

    {
      path: '/stock/items',
      listHeader: '材料管理',
      name: '库存',
      en_name: 'stock_item',
      icon: 'ion-navicon-round',
      meta: { auth_id: 51301 },
    },
    {
      path: '/stock/purchase_orders',
      name: '入库单',
      en_name: 'purchase_order',
      icon: 'ion-plus-round',
      meta: { auth_id: 51301 },
    },
    {
      path: '/stock/items/in',
      name: '入库记录',
      en_name: 'stock_item_in',
      icon: 'ion-clipboard',
      meta: { auth_id: 51301 },
    },
    {
      path: '/stock/item_outbound_orders',
      name: '出库单',
      en_name: 'item_outbound_order',
      icon: 'ion-minus-round',
      meta: { auth_id: 51301 },
    },
    {
      path: '/stock/items/out',
      name: '出库记录',
      en_name: 'stock_item_out',
      icon: 'ion-clipboard',
      meta: { auth_id: 51301 },
    },

    // {
    //   path: '/stock/inventory/pdc',
    //   listHeader: '库存盘点',
    //   name: '复合片',
    //   en_name: 'inventory_pdc',
    //   icon: 'ion-clipboard',
    //   meta: { auth_id: 51202 },
    // },
    // {
    //   path: '/stock/inventory/item',
    //   listHeader: '库存盘点',
    //   name: '材料',
    //   en_name: 'inventory_item',
    //   icon: 'ion-clipboard',
    //   meta: { auth_id: 51302 },
    // },
    // {
    //   path: '/stock/statistic/drill_cost',
    //   listHeader: '统计',
    //   name: '钻头成本核算',
    //   en_name: 'drill_cost',
    //   icon: 'ion-calculator',
    //   meta: { auth_id: 51501 },
    // },
    {
      name: '库存对象',
      listHeader: '库存对象管理',
      path: '/stock/materials',
      icon: 'ion-grid',
      en_name: 'stockMaterial',
      meta: { auth_id: 51301 },
    },
    {
      path: '/stock/stockrooms',
      listHeader: '基础信息',
      name: '仓库设置',
      en_name: 'stock_room',
      icon: 'ion-cube',
      meta: { auth_id: 51401 },
    },
  ],
  report: [
    {
      name: '项目管理',
      path: '/report/projects',
      icon: 'ion-grid',
      en_name: 'reportProject',
      listHeader: '业务管理',
      meta: { auth_id: 21100 },
    },
    {
      name: '归档项目',
      path: '/report/archive_projects',
      icon: 'ion-folder',
      en_name: 'reportArchiveProject',
      meta: { auth_id: 21100 },
    },
    {
      name: '钻头管理',
      path: '/report/drills',
      icon: 'ion-navigate',
      en_name: 'reportDrill',
      meta: { auth_id: 22100 },
    },
    {
      name: '钻头趟数',
      path: '/report/drill_trips',
      icon: 'ion-arrow-swap',
      en_name: 'reportDrillTrip',
      meta: { auth_id: 23100 },
    },
    {
      name: '钻头日报',
      path: '/report/reports',
      icon: 'ion-clipboard',
      en_name: 'reportReport',
      meta: { auth_id: 24100 },
    },
    {
      name: '人员管理',
      path: '/report/users',
      icon: 'ion-person-stalker',
      en_name: 'reportUser',
      listHeader: '人员管理',
      meta: { auth_id: 26100 },
    },
    {
      name: '区域管理',
      path: '/report/regions',
      icon: 'ion-map',
      en_name: 'reportRegion',
      listHeader: '基础配置',
      meta: { auth_id: 29100 },
    },
  ],
  purchase: [
    {
      name: '采购单列表',
      path: '/p/purchase_orders/item',
      icon: 'ion-clipboard',
      en_name: 'purchasePurchaseItem',
      listHeader: '采购单管理',
      meta: { auth_id: 61101 },
    },
    {
      name: '材料列表',
      path: '/p/materials',
      icon: 'ion-grid',
      en_name: 'purchaseMaterial',
      listHeader: '材料管理',
      meta: { auth_id: 61200 },
    },
    {
      name: '采购明细表',
      path: '/p/purchase_order_items',
      icon: 'ti-bar-chart',
      en_name: 'purchasePurchaseOrderItem',
      listHeader: '报表',
      meta: { auth_id: 61301 },
    },
    // {
    //   name: '采购结算表',
    //   path: '/p/sheet2',
    //   icon: 'ion-grid',
    //   en_name: 'purchaseSheet2',
    //   meta: { auth_id: 51401 },
    // },
    // {
    //   name: '执行统计表',
    //   path: '/p/sheet3',
    //   icon: 'ion-grid',
    //   en_name: 'purchaseSheet3',
    //   meta: { auth_id: 51401 },
    // },
    // {
    //   name: '未完成业务表',
    //   path: '/p/sheet4',
    //   icon: 'ion-grid',
    //   en_name: 'purchaseSheet4',
    //   meta: { auth_id: 51401 },
    // },
  ],
  finance: [
    {
      path: '/f/statistic/drill_cost',
      listHeader: '统计',
      name: '钻头成本核算表',
      en_name: 'drill_cost',
      icon: 'ion-calculator',
      meta: { auth_id: 71101 },
    },
    {
      path: '/f/statistic/drill_manhour',
      name: '钻头工时统计表',
      en_name: 'drill_manhour',
      icon: 'ion-calculator',
      meta: { auth_id: 71103 },
    },
  ],
  sale: [
    {
      path: '/sale/orders',
      listHeader: '订单管理',
      name: '销售订单',
      en_name: 'saleOrder',
      icon: 'ion-clipboard',
      meta: { auth_id: 71101 },
    },
  ],
  experiment: [
    {
      listHeader: '实验管理',
      name: '实验列表',
      path: '/experiment/experiments',
      icon: 'ion-lightbulb',
      en_name: 'experimentExperiment',
      meta: { auth_id: 91100 },
    },
  ],
}

export default {
  data() {
    return {
      menus: [],
      show: true,
    }
  },
  computed: {
    ...mapGetters(['userInfo']),
  },
  watch: {
    $route(to, from) {
      if (
        to.meta.module_name == 'stock' &&
        to.name != 'moduleDashboard' &&
        !this.show
      ) {
        this.show = true
      }
    },
  },
  created() {
    let module_name = this.$route.meta.module_name
    let p = this.$route.path.split('/')[1]
    if (p == 'report') {
      module_name = p
    }
    this.menus = siderMenus[module_name].map((item) => {
      item.show = hasAuth(item.meta.auth_id)
      return item
    })

    this.menus = this.menus.filter((item) => item.show == true)

    if (this.$route.name == 'moduleDashboard' && this.menus.length > 0) {
      if (this.$route.meta.module_name == 'stock') {
        this.show = false
        this.$router.replace({
          query: { redirect_url: this.menus[0].path },
        })
      } else if (this.$route.meta.module_name == 'report') {
        if (!this.userInfo.is_super_admin) {
          this.$router.replace(this.menus[0].path)
        }
      } else {
        this.$router.replace(this.menus[0].path)
      }
    }
  },
}
</script>